import React from "react";
import { money as fmtMoney } from "./tokens";
import { fmtDate } from "./productForm";

const PricingHistory = ({ product, classes }) => {
  const versions = product.pricingHistory || [];
  if (!versions.length) return null;
  return (
    <div className={classes.histWrap}>
      <div className={classes.histTitle}>Pricing history</div>
      <div className={classes.histTable}>
        <div className={`${classes.histRow} ${classes.histHead}`}>
          <span>Version</span><span>Total</span><span>Min price</span><span>From</span><span>To</span>
        </div>
        {versions.map((v) => (
          <div key={v.version} className={classes.histRow}>
            <span>v{v.version}{v.effectiveTo === null ? " · active" : ""}</span>
            <span>{fmtMoney(v.basePrice, v.currency)}</span>
            <span>{fmtMoney(v.minPrice, v.currency)}</span>
            <span>{fmtDate(v.effectiveFrom)}</span>
            <span>{v.effectiveTo === null ? "—" : fmtDate(v.effectiveTo)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingHistory;
